import { HttpRequest, HttpEvent, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../../services/admin/authentication.service';

export function apiAuthInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<any>> {
    const authService = inject(AuthenticationService);
    const sessionToken = authService.getCurrentUserSessionToken();

    if (sessionToken !== undefined)
    {
        const bearer = sessionToken ?? environment.apiAdminKey;
    
        req = req.clone({
            headers: req.headers.set('Authorization', 'Bearer ' + bearer)
        });
    }

    return next(req);
}